import { Button, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

const ErrorBoundaryFallback = () => {
  return (
    <Flex
      alignItems="center"
      flexDir="column"
      maxWidth="640px"
      width="100%"
      marginX="auto"
      marginTop="110px"
      marginBottom="25px"
    >
      <Heading
        as="h5"
        marginBottom="15px"
        textAlign="center"
        fontWeight={500}
        fontFamily="Gelica"
      >
        There is some issue in this page. You can refresh the page.
      </Heading>
      <Button
        fontFamily="ProximaNova"
        bgColor="neutral.900"
        color="neutral.0"
        width="120px"
        onClick={() => {
          window.location.reload();
        }}
      >
        Refresh
      </Button>
    </Flex>
  );
};

export default ErrorBoundaryFallback;
